import React from 'react';

export default function Header() {
  return (
    <div className='header'>
        <div className='logo'/>
    </div>
  );
}